module.exports = __webpack_public_path__ + "static/media/11-5.7bbf8090.mp3";